import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiIntegracao } from '../../../models/acesso-api/AcessoApi.model';
import { LoadingService } from '../../../util/loader.service';
import { AcessoApiService } from './acesso-api.service';

@Component({
  selector: 'app-acesso-api',
  templateUrl: './acesso-api.component.html',
  styleUrls: ['./acesso-api.component.scss']
})
export class AcessoApiComponent implements OnInit {
  record: ApiIntegracao;
  valForm: FormGroup;
  constructor(public service: AcessoApiService, public loader: LoadingService, fb: FormBuilder) {
    this.record = new ApiIntegracao();
    this.valForm = fb.group({
      'campoToken': [null, null]
    });

    this.loader.show("body");
    this.service.obter()
      .subscribe((itens) => {
        this.loader.hide("body");
        if (itens != null) {
          this.record = itens;
        }
      });
  }

  ngOnInit() {

  }

  gerarToken() {
    this.loader.show("body");
    this.service.create()
      .subscribe((itens) => {
        this.loader.hide("body");
        if (itens != null) {
          this.record = itens;
        }
      });
  }

}
